import type { ConfirmFooterProps } from "./types-confirm-footer";
import { useConfirmFooter } from "./use-confirm-footer";
import { ConfirmFooterView } from "./view-confirm-footer";

export type { ConfirmFooterOptions, ConfirmFooterProps } from "./types-confirm-footer";

/** Rodapé do `ConfirmDialog` (`footer` em função do Prime): erro inline e `DialogFooter` com o Cancelar do Figma. */
export function ConfirmFooter(props: ConfirmFooterProps) {
  return <ConfirmFooterView {...useConfirmFooter(props)} />;
}
